import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { DefaultMainLayoutComponent } from './modules/layout/components/default-main-layout/default-main-layout.component';
import { CanLoadParameterCheckRouteService } from './modules/core/services/guard/can-load-parameter-check-route.base';
import { CanActiveAuthorizationModuleService } from 'projects/authentication/src/app/services/guard';
import { DefaultLayoutComponent } from './modules/layout/components/default-layout/default-layout.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/login',
    pathMatch: 'full',
  },
  {
    path: 'summary',
    component: DefaultLayoutComponent,
    canLoad: [CanLoadParameterCheckRouteService],
    canActivate: [CanActiveAuthorizationModuleService],
    loadChildren: () => import('./modules/summary/summary.module').then((m) => m.SummaryModule),
  },
  {
    path: 'map',
    component: DefaultLayoutComponent,
    canLoad: [CanLoadParameterCheckRouteService],
    canActivate: [CanActiveAuthorizationModuleService],
    loadChildren: () => import('./modules/map/map.module').then((m) => m.MapModule),
  },
  {
    path: 'secondary-breaking/:name',
    component: DefaultLayoutComponent,
    canLoad: [CanLoadParameterCheckRouteService],
    canActivate: [CanActiveAuthorizationModuleService],
    loadChildren: () => import('./modules/secondary-breaking/secondary-breaking.module').then((m) => m.SecondaryBreakingModule),
  },
  {
    path: 'messenger',
    component: DefaultLayoutComponent,
    canLoad: [CanLoadParameterCheckRouteService],
    canActivate: [CanActiveAuthorizationModuleService],
    loadChildren: () => import('./modules/messenger/messenger.module').then((m) => m.MessengerModule),
  },
  {
    path: 'files',
    component: DefaultLayoutComponent,
    canLoad: [CanLoadParameterCheckRouteService],
    canActivate: [CanActiveAuthorizationModuleService],
    loadChildren: () => import('./modules/files/files.module').then((m) => m.FilesModule),
  },
  {
    path: 'report',
    component: DefaultLayoutComponent,
    canLoad: [CanLoadParameterCheckRouteService],
    canActivate: [CanActiveAuthorizationModuleService],
    loadChildren: () => import('./modules/report/report.module').then((m) => m.ReportModule),
  },
  {
    path: 'front/:name',
    component: DefaultLayoutComponent,
    canLoad: [CanLoadParameterCheckRouteService],
    canActivate: [CanActiveAuthorizationModuleService],
    loadChildren: () => import('./modules/front/front.module').then((m) => m.FrontModule),
  },
  {
    path: 'update-app',
    component: DefaultLayoutComponent,
    canLoad: [CanLoadParameterCheckRouteService],
    canActivate: [CanActiveAuthorizationModuleService],
    loadChildren: () => import('./modules/update/update.module').then((m) => m.UpdateModule),
  },
  {
    path: 'app',
    component: DefaultMainLayoutComponent,
    canLoad: [CanLoadParameterCheckRouteService],
    canActivate: [CanActiveAuthorizationModuleService],
    loadChildren: () => import('./modules/app/app.module').then((m) => m.AppModule),
  },
  {
    path: 'admin',
    component: DefaultLayoutComponent,
    canLoad: [CanLoadParameterCheckRouteService],
    canActivate: [CanActiveAuthorizationModuleService],
    loadChildren: () => import('./modules/administration/administration.module').then((m) => m.AdministrationModule),
  },
  {
    path: 'login',
    canLoad: [CanLoadParameterCheckRouteService],
    loadChildren: () => import('./modules/login/login.module').then((m) => m.LoginModule),
  },
  {
    path: '**',
    redirectTo: '/login',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
